import { Component, OnInit } from "@angular/core";
import { GraphService } from "../../services/administration/graph.service";
import { Sort } from "@angular/material/sort";
import { MatTableDataSource } from "@angular/material/table";
import { TableSortService } from "../../services/table-sort.service";
import { IUserData } from "../../interfaces/administration/userData";
import { ActivatedRoute, Router } from "@angular/router";
import { BaseComponent } from "../../shared/base/base.component";
import { UserService } from "../../services/administration/user.service";
import { LoggedUserService } from "../../services/common/logged-user.service";

@Component({
  selector: "users-roles-component",
  templateUrl: "./users-roles.component.html",
  styleUrls: ["users-roles.component.css"],
})
export class UsersAndRolesComponent extends BaseComponent implements OnInit {
  userPermissions: string;
  title = "Administration";
  subtitle = "Users & Roles";
  response: any[];
  usersLoading = true;

  userAndRolesPath = "administration/user-roles";

  dataSource: MatTableDataSource<IUserData>;
  originalDataSource: MatTableDataSource<IUserData>;

  displayedColumns = [
    "actions",
    "facilityId",
    "lastName",
    "firstName",
    "email",
    "isAdmin",
  ];

  ngOnInit(): void {
    super.ngOnInit();
    this.userService.getAllUsers().subscribe(
      (data) => {
        this.originalDataSource = new MatTableDataSource<IUserData>(data);
        this.dataSource = new MatTableDataSource<IUserData>(
          this.originalDataSource.data
        );
        this.usersLoading = false;
      },
      (error) => {
        console.error(error);
      });
  }

  constructor(
    private router: Router,
    private graphService: GraphService,
    private tableSortService: TableSortService,
    private userService: UserService,
    loggedUserService: LoggedUserService,
    route: ActivatedRoute
  ) {
    super(loggedUserService, route);
  }

  announceSortChange(event: Sort) {
    this.dataSource.data = this.tableSortService.sortDataSource(
      this.originalDataSource.data,
      event
    );
  }

  editUser(userData: IUserData) {
    this.graphService.updateUserData(userData);
    this.router.navigate([this.userAndRolesPath + "/edit-user"]);
  }

  applyFilter(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;
    this.dataSource.filterPredicate = (data: any, filter: string) => {
      const searchTerms = filter.toLowerCase().split(' ');
      return searchTerms.every(term =>
        data.firstName?.toLowerCase().includes(term) ||
        data.lastName?.toLowerCase().includes(term) ||
        data.email?.toLowerCase().includes(term)
      );
    };
    this.dataSource.filter = filterValue.trim().toLowerCase();

    if (this.dataSource.paginator) {
      this.dataSource.paginator.firstPage();
    }
  }
}
